import { ISideNavItem, SideNavRoute } from 'src/components-dummy';

export function allowedRoutesToArray(routes: ISideNavItem[]): string[] {
  return (routes as SideNavRoute[]).filter(r => r.url).map(r => r.url);
}
